// App.js
import React, { useState } from "react";
import './App.css';
import './media/css/media.css';
// imports
import 'bootstrap-icons/font/bootstrap-icons.css';

// sections
import Header from "./components/header"
import Home from './sections/home';
import About from "./sections/about"
import Resume from "./sections/resume"
import Portfolio from './sections/portfolio';
import Contact from "./sections/contact"

// body
function App() {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleSectionChange = (index) => {
    setActiveIndex(index);
    const sectionsId = ["home", "about", "resume", "portfolio", "contact"];
    sectionsId.forEach((id, idx) => {
      const section = document.getElementById(id);
      if (section) {
        section.classList.toggle("section-active", idx === index);
      }
    });
  };
  return (
    <div className="App">
      {/* header */}
      <Header activeIndex={activeIndex} onSectionChange={handleSectionChange} />
      {/* sections */}
      <Home onSectionChange={handleSectionChange} />
      <About />
      <Resume />
      <Portfolio />
      <Contact />
    </div>
  );
}

export default App;
